import { Injectable } from '@angular/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class MachineMappingService {
  // tslint:disable-next-line:typedef
  NetApiUrl: string = Constants.CORE_API_BASE_URL;
  constructor(private http: HttpClient) { }

  getMachineMappingData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Account/GetMachineMappingList', data);
  }

  getPlantsData(data: any): Observable<any[]> {
     return this.http.post<any[]>(this.NetApiUrl + 'Customers/GetAllPlantsInGroupByGroupCode', data);
  }

  getPlants(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Common/GetPlants', data);
 }

  getDepartmentData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Common/GetDepartmentByPlant', data);
  }
  getDepartmenBytPlant(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.apiUrl + 'getdepartmentbyplant', data);
    return this.http.post<any[]>(this.NetApiUrl + 'Machine/GetDepartmentByPlant', data);
  }

  getDepartmenBytPlantCode(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Machine_Core/GetDepartmentByPlant', data);
  }

  getAllDepartmentData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Common/GetAllDepartmentByPlant', data);
  }
  getProductData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Common/GetProdLine', data);
  }

  getUnitData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Common/GetProdUnit', data);
  }

  AddMachineData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Account/SumbitMachineMapping', data);
  }
  getLineList(data: any): Observable<any> {
    return this.http.get<any[]>(this.NetApiUrl + 'Dashboard/GetLineList', data);
  }
  getUnitList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Dashboard/GetUnitList', data);
  }
  getAssemblyList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Dashboard/GetAssemblyList', data);
  }
  getComponentListByAssembly(data: any): Observable<any> {
    return this.http.post<any>(this.NetApiUrl + 'Dashboard/GetComponentListByAssembly', data);
  }
  getUnitbyUser(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Machine/GetUnitsByUser', data);
  }
  getDepartmentsByPlant(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Machine/GetDepartmentByPlant', data);
  }
  async getComponentbyUnit(data: any): Promise<any> {
    return await this.http.post<any>(this.NetApiUrl + 'Machine/GetComponentByUnit', data).toPromise();
  }

  GetTreeMasterData(data:any): Observable<any[]> {
    return this.http.post<any>(this.NetApiUrl + 'Common/GetTreeMasterData', data);
  } 


}
